module.exports = __webpack_public_path__ + "img/iconNo12.7aa5418d.png";